export default "__VITE_ASSET__BHNc45et__"